// frontend/src/sections/Home/Hero/HeroBg.jsx

import React from "react";

export default function HeroBg() {
  return (
    <div
      className="pointer-events-none absolute inset-0 z-0 overflow-hidden"
      aria-hidden="true"
    >
      <img
        src="/images/hero-1.png"
        alt=""
        className="absolute inset-0 h-full w-full object-cover object-center opacity-[0.22] mix-blend-luminosity"
      />

      <div className="absolute inset-0 bg-[linear-gradient(100deg,#07150F_8%,rgba(7,21,15,.93)_44%,rgba(7,21,15,.7)_74%,rgba(7,21,15,.5)_100%)]" />
      <div className="absolute inset-0 bg-[linear-gradient(to_top,#07150F_0%,transparent_45%,rgba(7,21,15,.3)_100%)]" />

      {/* راه‌راه چمن */}
      <div className="pitch-stripes absolute inset-0" />

      {/* شبکه */}
      <div className="pitch-lines absolute inset-0 opacity-50" />

      {/* دایره‌ی وسط زمین و خط میانی */}
      <div className="absolute left-[8%] top-1/2 h-[560px] w-[560px] -translate-y-1/2 rounded-full border border-white/[0.07]" />
      <div className="absolute left-[8%] top-1/2 h-[560px] w-[560px] -translate-y-1/2 scale-[0.5] rounded-full border border-white/[0.06]" />
      <div className="absolute inset-y-0 left-[8%] ml-[280px] w-px bg-white/[0.06]" />

      <div className="absolute right-[12%] top-[18%] h-2 w-2 rounded-full bg-floodlight shadow-[0_0_30px_8px_rgba(214,255,61,.3)]" />
      <div className="absolute left-[18%] top-[32%] h-1.5 w-1.5 rounded-full bg-emerald-400 shadow-[0_0_25px_6px_rgba(52,211,153,.3)]" />
    </div>
  );
}
